import { GetUserTenantsDto } from "../../dtos/login/GetUserTenantsDto";
import { LoggedInDetails } from "../../dtos/login/LoggedInDetails";
import instance from "../../utills/BaseService";

export const loginApi = (credentials: LoggedInDetails) => instance.post("/user/login", credentials);
export const getUserTenants = (credentials: GetUserTenantsDto) => instance.post("/user/getUserTenants", credentials);